import {createActionGroup, props} from '@ngrx/store';
import {Conversation} from "@twilio/conversations";

export const ChatActions = createActionGroup({
  source: '[Chat]',
  events: {
    setIsOpen:  props<{ isOpen: boolean }>(),
    setConversation:  props<{ conversation: Conversation }>(),
    setUnreadCount:  props<{ unreadCount: number }>(),
  },
});
